export const LOGIN_URL = 'https://data.kigam.re.kr/auth/login'
// export const LOGIN_AND_CLOSE_URL = 'https://data.kigam.re.kr/auth/login?redirect=https://data.kigam.re.kr/quake/sso-login-callback'
export const LOGIN_AND_CLOSE_URL = 'https://data.kigam.re.kr/auth/login?redirect=/quake/sso-login-callback'
// export const LOGOUT_URL = 'https://data.kigam.re.kr/auth/logout'
export const LOGOUT_URL = 'https://data.kigam.re.kr/auth/logout?redirect=/quake/'
export const MYPAGE_URL = 'https://data.kigam.re.kr/auth/me/'


export const HTTP_RESPONSE_STATUS_FORBIDDEN_IN_THIS_MONTH = 491


export const NUMBER_OF_EVENT_RECORDS_CAN_BE_DOWNLOADED_AT_ONE_TIME = 50